import { urlsPages } from "../../../../common/urls/urls-pages"
import { Plan } from "../domain/plan"
import { PlanDto } from "../../infra/repository/dto/plans.dto"
import { PlansRepository } from "../../infra/repository/plans.repository"

export interface ListPlansResult {
    plans: Plan[]
    error: boolean
}

function formatPrice(price: string): string {
    const trimmed = price?.trim()
    if (!trimmed || Number.isNaN(Number(trimmed))) return "R$ —"
    return `R$ ${trimmed}`
}

function formatPeriod(paymentPeriodPlan: string): string {
    if (paymentPeriodPlan === "monthly") return "/ mês"
    return ""
}

function buildHref(dto: PlanDto): string {
    if (dto.price === "0") return urlsPages.signup
    return `${urlsPages.signup}?plan=${dto.id}`
}

function toPlan(dto: PlanDto): Plan {
    return {
        id: dto.id,
        name: dto.name,
        price: formatPrice(dto.price),
        period: formatPeriod(dto.payment_period_plan),
        highlight: dto.highlight,
        features: dto.features_list ?? [],
        cta: dto.description,
        href: buildHref(dto),
    }
}

export class ListPlansUseCase {
    static async execute(): Promise<ListPlansResult> {
        try {
            const response = await PlansRepository.list()
            if (response.error || !Array.isArray(response.data)) {
                return { plans: [], error: true }
            }

            const plans = response.data
                .filter((plan) => plan.status === "active")
                .map(toPlan)

            return { plans, error: false }
        } catch {
            return { plans: [], error: true }
        }
    }
}
